import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router';
import './index.css';
import './testData.js'

import reportWebVitals from './reportWebVitals';

import _ from 'lodash';

import EurydiceStaticDataDump from './components/RydStaticDataDump.js';
import {
  EurydiceChordRecognizer,
  EurydiceChordRoll,
  EurydiceComponentsCollection,
  EurydiceContextPlane,
  EurydicePianoRollKeybed,
  EurydicePianoRollViewport,
  EurydicePROperationContainer,
  EurydiceDurationSelector,
  EurydiceContextTimeSignature,
  EurydiceCollpasedRolls,
  EurydiceMidiTestbed,
  EurydiceTonalitySelector,
  EurydiceHighlightColors
} from './testbeds/EurydiceTestbed';
import EurydiceDevelopmentHome from './components/EurydiceDevelopmentHome.js';
import { EurydiceRoot } from './components/layouts/EurydiceApp';
import EurydicePlaybackTestbed from './testbeds/Playback';
import EurydiceLoadingSpinnerTestbed from './testbeds/EurydiceLoadingSpinnerTestbed';
import { EurydiceProfilingHome } from './testbeds/EurydiceProfilingHome';

import { EurydiceChordSelectorTestbed } from './testbeds/EurydiceChordSelectorTestbed';

import { EurydiceFretboardTestbed } from './testbeds/EurydiceFretboardTestbed';
import EurydiceTestbedsHome from './testbeds/EurydiceTestbedHome';
import EurydiceAudioCaptureTunerTestbed from './testbeds/EurydiceAudioCaptureTunerTestbed';
import { EurydiceScaleSelectorTestbed } from './testbeds/EurydiceScaleSelectorTestbed';
import RydLogin from './components/account/RydLogin';
import { EurydiceSelectedNotesInfoboxTestbed } from './testbeds/EurydiceSelectedNotesInfoboxTestbed';
import { VirtualInstrumentsTestbed } from './testbeds/VirtualInstrumentsTestbed';
import { MidiLoaderTestbed } from './testbeds/MidiLoaderTestbed';
import { PianoRollBackgroundTestbed } from './testbeds/PianoRollBackgroundTestbed';
import { UserAccountPanelTestbed } from './testbeds/UserAccountPanelTestbed';
import { ScaleIdentifyierTestbed } from './testbeds/ScaleIdentifyierTestbed';
import { InstrumentSelectionDialogTestbed } from './testbeds/InstrumentSelectionDialogTestbed';
import { NoteRangeSelectorTestbed } from './testbeds/NoteRangeSelectorTestbed';
import { MetronomePatternTestbed } from './testbeds/MetronomePatternTestbed';
import { MixerPanelTestbed } from './testbeds/MixerPanelTestbed';
import { PianoRollTestbed } from './testbeds/PianoRollTestbed';
import { MiniWindowTestbed } from './testbeds/MiniWindowTestbed';
import { ColorTableTestbed } from './testbeds/ColorTableTestbed';
import { RydNumericInputTestbed } from './testbeds/RydNumericInputsTestbed';
import { GridResolutionDialogTestbed } from './testbeds/GridResolutionDialogTestbed';
import { PlaybackCaretIndicatorDialogTestbed } from './testbeds/PlaybackCarretIndicatorDialogTestbed';
import { ProjectMainOptionsTestbed } from './testbeds/ProjectMainOptionsTestbed';
import { AudioInputSelectorTestbed } from './testbeds/AudioInputSelectorTestbed';
import { RydSpectrogramTestbed } from './testbeds/RydSpectrogramTestbed';
import { SampleNavigatorTestbed } from './testbeds/SampleNavigatorTestbed';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(

  <BrowserRouter>
    <Routes>
      <Route path="/app" element={<EurydiceRoot />} />
      <Route path="/login" element={<RydLogin />} />

      {/* Development routes */}

      {/* m7 */}
      <Route path="/testbeds/testbeds/MixerPanelTestbed" element={<MixerPanelTestbed />} />



      {/* Widget testbeds */}
      <Route path="/testbeds/widgets/spinner" element={<EurydiceLoadingSpinnerTestbed />} />
      <Route path="/testbeds/testbeds/ColorTableTestbed" element={<ColorTableTestbed />} />
      <Route path="/testbeds/widgets/chord-selector" element={<EurydiceChordSelectorTestbed />} />
      <Route path="/testbeds/widgets/scale-selector" element={<EurydiceScaleSelectorTestbed />} />
      <Route path="/testbeds/widgets/fretboard" element={<EurydiceFretboardTestbed />} />
      <Route path="/testbeds/virtual-instruments" element={<VirtualInstrumentsTestbed />} />
      <Route path="/testbeds/PianoRollBackground" element={<PianoRollBackgroundTestbed />} />
      <Route path="/testbeds/testbeds/RydNumericInputTestbed" element={<RydNumericInputTestbed />} />

      <Route path="/testbeds/widgets/selected-notes-infobox" element={<EurydiceSelectedNotesInfoboxTestbed />} />

      {/* Component testbeds */}
      <Route path="/" element={<EurydiceDevelopmentHome />} />
      <Route path="/components/" element={<EurydiceTestbedsHome />} />
      <Route path="/components/all" element={<EurydiceComponentsCollection />} />
      <Route path="/components/piano-roll-viewport" element={<EurydicePianoRollViewport />} />
      <Route path="/components/piano-roll-keybed" element={<EurydicePianoRollKeybed />} />
      <Route path="/components/piano-roll-operations-container" element={<EurydicePROperationContainer />} />
      <Route path="/testbeds/testbeds/PianoRollTestbed" element={<PianoRollTestbed />} />
      <Route path="/testbeds/testbeds/PianoRollBackgroundTestbed" element={<PianoRollBackgroundTestbed />} />
      <Route path="/components/context-plane" element={<EurydiceContextPlane />} />
      <Route path="/components/chord-roll" element={<EurydiceChordRoll />} />
      <Route path="/components/chord-recognizer" element={<EurydiceChordRecognizer />} />
      <Route path="/components/duration-selector" element={<EurydiceDurationSelector />} />
      <Route path="/components/collapsed-rolls" element={<EurydiceCollpasedRolls />} />
      <Route path="/components/midi-controls" element={<EurydiceMidiTestbed />} />
      <Route path="/components/tonality-selector" element={<EurydiceTonalitySelector />} />
      <Route path="/components/highlight-colors" element={<EurydiceHighlightColors />} />
      <Route path="/testbeds/testbeds/MidiLoaderTestbed" element={<MidiLoaderTestbed />} />
      <Route path="/testbeds/testbeds/NoteRangeSelectorTestbed" element={<NoteRangeSelectorTestbed />} />
      <Route path="/testbeds/testbeds/MetronomePatternTestbed" element={<MetronomePatternTestbed />} />
      <Route path="/testbeds/testbeds/MiniWindowTestbed" element={<MiniWindowTestbed />} />
      <Route path="/testbeds/testbeds/GridResolutionDialogTestbed" element={<GridResolutionDialogTestbed />} />
      <Route path="/testbeds/testbeds/PlaybackCaretIndicatorDialogTestbed" element={<PlaybackCaretIndicatorDialogTestbed />} />
      <Route path="/testbeds/testbeds/ProjectMainOptionsTestbed" element={<ProjectMainOptionsTestbed />} />

      <Route path="/testbeds/playback" element={<EurydicePlaybackTestbed />} />
      <Route path="/testbeds/capture-tuner" element={<EurydiceAudioCaptureTunerTestbed />} />

      <Route path="/components/context-time-signature" element={<EurydiceContextTimeSignature />} />
      <Route path="/components/context-plane" element={<EurydiceContextPlane />} />

      <Route path="/testbeds/testbeds/InstrumentSelectionDialogTestbed" element={<InstrumentSelectionDialogTestbed />} />
      <Route path="/testbeds/testbeds/AudioInputSelectorTestbed" element={<AudioInputSelectorTestbed />} />
      <Route path="/testbeds/testbeds/RydSpectrogramTestbed" element={<RydSpectrogramTestbed />} />

      <Route path="/testbeds/testbeds/SampleNavigatorTestbed" element={<SampleNavigatorTestbed />} />

      {/* Data dump */}
      <Route path="/static-dump" element={<EurydiceStaticDataDump />} />

      {/* Profiling */}
      <Route path="/component-profiling/" element={<EurydiceProfilingHome />} />

      <Route path="/testbeds/testbeds/UserAccountPanelTestbed" element={<UserAccountPanelTestbed />} />
      <Route path="/testbeds/testbeds/ScaleIdentifyierTestbed" element={<ScaleIdentifyierTestbed />} />
    </Routes>
  </BrowserRouter>

);
//<HorizontalContext data={testData} />
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
